import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'
import { injectIntl, FormattedMessage } from 'react-intl'
import { DATE_NAME_MAX_LENGTH } from 'const/limits'
import {
  ControlLabel,
  ButtonGroup,
  FormControl
} from 'react-bootstrap'
import Scrollbars from 'components/Scrollbars'
import CardDateAction from 'components/CardActions/Date'
import RelativeDate from 'components/RelativeDate'
import Editable from 'components/Editable'
import {
  ToggleModal
} from 'components/Modal'
import {
  ListItem
} from 'components/List'
import Button from 'components/Button'
import KanBoIcon from 'components/KanBoIcon'
import ElementItem from '../ElementItem'
import classes from './CardDate.module.scss'
import { withBoardPermission } from 'dataProviders/Board'

const ModalActions = {
  CHANGE_DATE: 1,
  REMINDERS: 2,
  ADD_REMINDER: 3
}

const RELATIVE_REMINDERS = [
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_ON_TIME'
    },
    subtract: [0, 'minutes']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_MINUTES',
      values: {
        minutes: 5
      }
    },
    subtract: [5, 'minutes']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_MINUTES',
      values: {
        minutes: 15
      }
    },
    subtract: [15, 'minutes']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_MINUTES',
      values: {
        minutes: 30
      }
    },
    subtract: [30, 'minutes']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_HOURS',
      values: {
        hours: 1
      }
    },
    subtract: [1, 'hour']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_HOURS',
      values: {
        hours: 2
      }
    },
    subtract: [2, 'hours']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_HOURS',
      values: {
        hours: 4
      }
    },
    subtract: [4, 'hours']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_HOURS',
      values: {
        hours: 8
      }
    },
    subtract: [8, 'hours']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_HOURS',
      values: {
        hours: 12
      }
    },
    subtract: [12, 'hours']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_DAYS',
      values: {
        days: 1
      }
    },
    subtract: [1, 'day']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_DAYS',
      values: {
        days: 2
      }
    },
    subtract: [2, 'days']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_DAYS',
      values: {
        days: 3
      }
    },
    subtract: [3, 'days']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_DAYS',
      values: {
        days: 4
      }
    },
    subtract: [4, 'days']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_WEEKS',
      values: {
        weeks: 1
      }
    },
    subtract: [7, 'days']
  },
  {
    formattedMessage: {
      id: 'REMINDERS_RELATIVE_WEEKS',
      values: {
        weeks: 2
      }
    },
    subtract: [14, 'days']
  }
]

export class CardDate extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,

    cardContext: PropTypes.object.isRequired,

    permission: PropTypes.object.isRequired,

    isArchived: PropTypes.bool.isRequired,
    alarms: PropTypes.array.isRequired,

    requestAddAlarm: PropTypes.func.isRequired,
    requestRemoveAlarm: PropTypes.func.isRequired,

    id: PropTypes.number,
    name: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    date: PropTypes.number.isRequired,
    onRemove: PropTypes.func.isRequired,
    editableName: PropTypes.bool,
    icon: PropTypes.element,
    subtitle: PropTypes.element,
    style: PropTypes.string,
    onNameChange: PropTypes.func,
    onDateChange: PropTypes.func
  }

  state = {
    modalAction: null,
    selectedRelativeReminderIndex: null
  }

  handleModalToggle = (show) => {
    if (show === false) {
      this.setState({
        modalAction: null
      })
    }
  }

  handleChangeDateClick = () => {
    this.setState({
      modalAction: ModalActions.CHANGE_DATE
    })
  }

  handleReminderCountClick = (event) => {
    event.stopPropagation()

    this.handleRemindersClick()
  }

  handleRemindersClick = () => {
    this.setState({
      modalAction: ModalActions.REMINDERS
    })
  }

  handleRemoveDateClick = () => {
    this.props.onRemove()
  }

  handleNameValidate = ({ name }) => {
    const errors = {}
    if (!name) {
      errors.name = this.props.intl.formatMessage({ id: 'DATE_NAME_EMPTY' })
    } else if (name.length > DATE_NAME_MAX_LENGTH) {
      errors.name = this.props.intl.formatMessage({ id: 'DATE_NAME_TOO_LONG' }, { limit: DATE_NAME_MAX_LENGTH })
    }
    return errors
  }

  handleNameSubmit = ({ name }) => {
    const { onNameChange } = this.props

    if (name && name !== this.props.name) {
      onNameChange && onNameChange(name)
    }
  }

  handleDateChange = (date) => {
    this.props.onDateChange(date)

    this.setState({
      modalAction: null
    })
  }

  handleRelativeReminderIndexChange = (event) => {
    this.setState({
      selectedRelativeReminderIndex: +event.target.value
    })
  }

  render () {
    const {
      intl,

      cardContext,

      permission,
      isArchived,
      alarms,

      requestAddAlarm,
      requestRemoveAlarm,

      id,
      name,
      date,
      onRemove,
      editableName,
      icon,
      subtitle,
      style,
      onNameChange,
      onDateChange,

      ...props
    } = this.props
    const {
      modalAction,
      selectedRelativeReminderIndex
    } = this.state

    const menu = [{
      icon: <KanBoIcon fixedWidth name='kanbo-16-notifications' />,
      title: <FormattedMessage id='REMINDERS' />,
      onClick: this.handleRemindersClick
    }]
    if (!isArchived && permission.member) {
      menu.push({
        icon: <KanBoIcon fixedWidth name='kanbo-16-remove-due-date' />,
        title: <FormattedMessage id='REMOVE' />,
        onClick: this.handleRemoveDateClick
      })
    }

    let styleClassName
    if (style === 'danger') {
      styleClassName = 'text-danger'
    } else if (style === 'warning') {
      styleClassName = 'text-warning'
    }

    return (
      <ToggleModal
        backdrop
        show={modalAction}
        onToggle={this.handleModalToggle}
        attachment='top left'
        targetAttachment='top right'
        constraints={[
          {
            to: 'window',
            pin: true
          }
        ]}
      >
        <ElementItem
          {...props}
          subtitle={
            <React.Fragment>
              <FormattedMessage
                id='DATE_FORMAT_FULL'
                values={{
                  date: moment(date).format('LLLL'),
                  week: moment(date).format('w'),
                }}
              >
                {formattedMessage =>
                  <div title={formattedMessage}>
                    {moment(date).format('D MMM LT')} (<RelativeDate timestamp={date} />)
                  </div>
                }
              </FormattedMessage>
              {alarms.length > 0 &&
              <div className={classes.section}>
                <span
                  className={classes.alarmCount}
                  onClick={this.handleReminderCountClick}
                >
                  <KanBoIcon name='kanbo-16-notifications' className={classes.icon} />
                  <FormattedMessage
                    id='REMINDERS_COUNT'
                    values={{
                      count: alarms.length
                    }}
                  />
                </span>
              </div>
              }
              {subtitle &&
                <div className={classes.section}>
                  {subtitle}
                </div>
              }
            </React.Fragment>
          }
          icon={
            icon ? (
              <span className={styleClassName}>
                {icon}
              </span>
            ) : undefined
          }
          menu={menu}
          onClick={isArchived ? undefined : this.handleChangeDateClick}
        >
          <span className={styleClassName}>
            {(editableName && !isArchived && permission.member) &&
              <Editable
                initialValues={{ name }}
                onSubmit={this.handleNameSubmit}
                validate={this.handleNameValidate}
              >
                {name}
              </Editable>
            }
            {!(editableName && !isArchived && permission.member) &&
              name
            }
          </span>
        </ElementItem>
        <Scrollbars
          className={classes.modal}
        >
          {modalAction === ModalActions.CHANGE_DATE &&
            <CardDateAction
              date={date}
              onDateChange={this.handleDateChange}
            />
          }
          {modalAction === ModalActions.REMINDERS &&
            <React.Fragment>
              <div className={classes.paddedContent}>
                <ControlLabel>
                  <FormattedMessage id='REMINDERS' />
                </ControlLabel>
                <Button
                  block
                  style={{ textAlign: 'left' }}
                  icon={<KanBoIcon name='kanbo-16-plus' />}
                  disabled={moment(date).isBefore()}
                  onClick={() => {
                    this.setState({
                      modalAction: ModalActions.ADD_REMINDER,
                      selectedRelativeReminderIndex: 0
                    })
                  }}
                >
                  <FormattedMessage id='ADD' />
                </Button>
              </div>
              {alarms.map(alarm =>
                <ListItem
                  key={alarm.id}
                  icon={<KanBoIcon name='kanbo-16-notifications' />}
                  menu={[{
                    icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
                    title: <FormattedMessage id='REMOVE' />,
                    onClick: () => {
                      requestRemoveAlarm({ id: alarm.id })
                    }
                  }]}
                >
                  <FormattedMessage
                    id='DATE_FORMAT_FULL'
                    values={{
                      date: moment(alarm.timestamp).format('LLLL'),
                      week: moment(alarm.timestamp).format('w'),
                    }}
                  >
                    {formattedMessage =>
                      <div title={formattedMessage}>
                        {moment(alarm.timestamp).format('D MMM LT')} (<RelativeDate timestamp={alarm.timestamp} />)
                      </div>
                    }
                  </FormattedMessage>
                </ListItem>
              )}
            </React.Fragment>
          }
          {modalAction === ModalActions.ADD_REMINDER &&
            <div className={classes.paddedContent}>
              <FormControl
                componentClass='select'
                value={selectedRelativeReminderIndex}
                onChange={this.handleRelativeReminderIndexChange}
              >
                {RELATIVE_REMINDERS
                  .filter(relativeReminder => !moment(date).subtract(...relativeReminder.subtract).isBefore())
                  .map((relativeReminder, index) =>
                    <FormattedMessage
                      {...relativeReminder.formattedMessage}
                      key={index}
                    >
                      {formattedMessage =>
                        <option
                          value={index}
                        >
                          {formattedMessage}
                        </option>
                      }
                    </FormattedMessage>
                  )
                }
              </FormControl>
              <div className='m-t-10'>
                <ButtonGroup>
                  <Button
                    bsStyle='primary'
                    icon={<KanBoIcon name='kanbo-16-plus' />}
                    onClick={() => {
                      requestAddAlarm({
                        eventId: id,
                        timestamp: moment(date).subtract(...RELATIVE_REMINDERS[selectedRelativeReminderIndex].subtract).valueOf()
                      })

                      this.setState({
                        modalAction: ModalActions.REMINDERS
                      })
                    }}
                  >
                    <FormattedMessage id='ADD' />
                  </Button>
                  <Button
                    onClick={() => {
                      this.setState({
                        modalAction: ModalActions.REMINDERS
                      })
                    }}
                  >
                    <FormattedMessage id='CANCEL' />
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          }
        </Scrollbars>
      </ToggleModal>
    )
  }
}

export default injectIntl(withBoardPermission(CardDate))
